import { Pipe, PipeTransform } from '@angular/core';
import { Result } from './result';

@Pipe({
  name: 'isResultWithinMicrotimeRange'
})
export class IsResultWithinMicrotimeRangePipe implements PipeTransform {

  transform(
    result: Result,
    [startAfterMicrotime, endAtMicrotime]: [number, number]
  ): boolean {
    return (result.createdAt * 1000) - result.microtime > startAfterMicrotime
      && (result.createdAt * 1000) <= endAtMicrotime;
  }

}
